export const DAY = 86400000;
export const toTs = (d) => new Date(`${d}T12:00:00`).getTime();
export const fmtDate = (t) => new Date(t).toLocaleDateString("nl-NL", { day: "numeric", month: "short", year: "2-digit" });

export const measureConfig = (pvp) => {
  const m = pvp.sections?.meetplan || {};
  const s = pvp.sections?.specificatie || {};
  const num = (v) => (v === "" || v === undefined || v === null ? null : Number(v));
  const pct = m.kwantiteit_eenheid === "Percentages";
  const counting = (m.tellen_oordelen || "").toLowerCase().startsWith("tellen");
  const cats = m.categorie || "";
  let label = "Waarde";
  if (pct) label = "Percentage";
  else if (cats.includes("Kwantiteit") || counting) label = "Aantal";
  else if (cats.includes("Kosten")) label = "Bedrag (€)";
  else if (cats.includes("Tijdigheid")) label = "Tijd";
  else if (cats.includes("Kwaliteit")) label = "Score";
  return {
    lo: num(m.ondergrens), hi: num(m.bovengrens), base: num(m.nulmeting_waarde),
    goal: num(s.hoofddoel_waarde), goalDate: s.hoofddoel_datum || "", freq: s.hoofddoel_frequentie || "",
    sfx: pct ? "%" : "", label, step: pct || counting || cats.includes("Kwantiteit") ? 1 : "any",
    what: m.wat || "", subgoals: parseList(pvp.sections?.subdoelen?.doelen),
  };
};

export function parseList(s) {
  try { return JSON.parse(s || "[]"); } catch { return []; }
}

export const numbered = (list) => list.map((x, i) => ({ ...x, nr: i + 1 }));
